import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../logos/Logo-h-tran.png';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Hamburger Icon for Mobile */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <div></div>
          <div></div>
          <div></div>
        </div>

        {/* Navigation Links */}
        <div className={`nav-links-container ${menuOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li><Link to="/" className="nav-link hover-link" onClick={() => setMenuOpen(false)}>Home</Link></li>
            <li><Link to="/about" className="nav-link hover-link" onClick={() => setMenuOpen(false)}>About Us</Link></li>
            <li><Link to="/how-it-works" className="nav-link hover-link" onClick={() => setMenuOpen(false)}>How It Works</Link></li>
            <li><Link to="/contact" className="nav-link hover-link" onClick={() => setMenuOpen(false)}>Contact Us</Link></li>
          </ul>
        </div>

        {/* Centered Logo */}
        <div className="logo-container">
          <img src={logo} alt="Top Tier Benefits Logo" className="logo" />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
